"use client";
import React from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/Button";
import { useAuth } from "@/context/AuthContext";
// import { saveCurrentUrl } from "@/utils/utils";
import { matchSiteConfig } from "@/utils/getApiBaseUrl";

const DownloadButton = () => {
  const { sessionUser } = useAuth();
  const router = useRouter();

  const handleDownloadPDF = () => {
    if (!sessionUser?.subscriber_id) {
      // Store the current page URL before redirecting to signup
      // saveCurrentUrl();
      router.push("/auth/login");
      return;
    }
    
    // Get site configuration to determine which brochure to download
    const { siteType } = matchSiteConfig(window.location.hostname);
    
    // Select brochure based on site type
    let brochurePath
    
    switch (siteType) {
      case "ME":
        brochurePath = `${process.env.NEXT_PUBLIC_ASSET_URL}/documents/73bbd451-b16f-452e-8c7d-e4e254e2d523.pdf`;
        break;
      case "ANZ":
        brochurePath = `${process.env.NEXT_PUBLIC_ASSET_URL}/documents/963cec0f-8449-426d-b0d9-78515f2e025e.pdf`;
        break;
      case "IN":
        brochurePath = `${process.env.NEXT_PUBLIC_ASSET_URL}/documents/963cec0f-8449-426d-b0d9-78515f2e025e.pdf`;
        break;
      case "GLOBAL":
        brochurePath = `${process.env.NEXT_PUBLIC_ASSET_URL}/documents/963cec0f-8449-426d-b0d9-78515f2e025e.pdf`;
        break;
      default:
        brochurePath = `${process.env.NEXT_PUBLIC_ASSET_URL}/documents/73bbd451-b16f-452e-8c7d-e4e254e2d523.pdf`;
    }
    
    // If user is logged in, proceed with download
    // window.open("/documents/963cec0f-8449-426d-b0d9-78515f2e025e.pdf", "_blank");
    window.open(brochurePath, "_blank");
  };

  return (
    <Button
      className="whitespace-nowrap w-full lg:w-auto"
      colorVariant="secondary"
      onClick={handleDownloadPDF}
    >
      DOWNLOAD OFFICIAL SPONSORSHIP DECK
    </Button>
  );
};

export default DownloadButton; 